import React, { useEffect } from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import { updateMeta, setCanonicalUrl, setSocialTags } from '@/lib/canonical';

import BenefitsSection from '@/components/BenefitsSection';
import TemplateGallery from '@/components/TemplateGallery';
import LogoCarousel from '@/components/LogoCarousel';

import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import ConsentBanner from '@/components/ConsentBanner';

const Index = () => {
  // Handle smooth scrolling for anchor links with performance optimization
  useEffect(() => {
    const handleHashChange = () => {
      const { hash } = window.location;
      if (hash) {
        // Small delay to ensure DOM is ready
        requestAnimationFrame(() => {
          const element = document.getElementById(hash.slice(1));
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }
        });
      }
    };

    // Call once on mount in case there's already a hash in the URL
    handleHashChange();

    // Add listener for hash changes
    window.addEventListener('hashchange', handleHashChange, { passive: true });
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // SEO-specific meta tags
  useEffect(() => {
    // Update meta tags for SEO
    document.title = "AD Email Lab - Professional CRM Email Templates & Development";

    updateMeta('description', 'Professional CRM email services with lightning-fast delivery of optimized HTML/CSS templates that look perfect on every device and email client.');
    updateMeta('keywords', 'CRM email, HTML email templates, responsive email design, email development, email marketing, email automation, email strategy');

    // Set canonical URL for homepage
    setCanonicalUrl('');
    setSocialTags({
      title: 'AD Email Lab - Professional CRM Email Templates',
      description: 'Professional CRM email services with optimized HTML/CSS templates that look perfect on every device and email client.',
      path: '',
      type: 'website',
    });
  }, []);
  
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      
      <BenefitsSection />
      <TemplateGallery />
      <LogoCarousel />
      
      <ContactSection />
      <Footer />
      <ScrollToTop />
      <ConsentBanner />
    </div>
  );
};

export default Index;
